import createIcon from '../../createIcon';

/**
 * @component @name NearMe
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0wzIDEwLjUzVjExLjUxTDkuODQgMTQuMTZMMTIuNDggMjFIMTMuNDZMMjEgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NearMe = createIcon('NearMe', [
  ['path', { d: 'M21 3L3 10.53V11.51L9.84 14.16L12.48 21H13.46L21 3Z', key: '8uxffq' }],
]);

export default NearMe;
